import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  archiveBillingAddress,
  createBillingAddress,
  fetchBillingAddresses,
} from "@/api/billingAddresses";
import type { BillingAddressPayload } from "@/interfaces/billingAddresses";

export const billingAddressesKey = (groupId: number) => ["billingAddresses", groupId] as const;

export function useBillingAddresses(groupId: number | null | undefined) {
  return useQuery({
    queryKey: ["billingAddresses", groupId],
    queryFn: () => fetchBillingAddresses(groupId as number),
    enabled: groupId != null,
  });
}

export function useCreateBillingAddress(groupId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: BillingAddressPayload) => createBillingAddress(groupId, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: billingAddressesKey(groupId) }),
  });
}

/** Removes an address from the book (kept in the DB, flagged inactive). */
export function useArchiveBillingAddress(groupId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (addressId: number) => archiveBillingAddress(groupId, addressId),
    onSuccess: () => qc.invalidateQueries({ queryKey: billingAddressesKey(groupId) }),
  });
}
